import React from 'react';
import { Award, GraduationCap } from 'lucide-react';

const RecognitionWorkshops = () => {
  const achievements = [
    {
      type: 'award',
      title: 'Dadasaheb Phalke Film Puraskar',
      subtitle: 'Best Short Film',
      description: 'Won the prestigious Dadasaheb Phalke Film Puraskar of India 2024-25 for the short film "Rinti" - a powerful narrative that explores themes of strength and equality.',
      year: '2024-25',
      image: 'https://customer-assets.emergentagent.com/job_rrammy-films/artifacts/kvqcuu0r_490420850_2162950434155556_2511737731244059271_n.jpg',
      icon: Award
    },
    {
      type: 'workshop',
      title: 'Guest Speaker at IIT Bombay',
      subtitle: 'Science of Film Making',
      description: 'Conducted workshops and masterclasses at the prestigious Indian Institute of Technology Bombay (IIT Bombay), sharing insights on the art and science of filmmaking with aspiring filmmakers and students.',
      year: '2025',
      image: 'https://customer-assets.emergentagent.com/job_rrammy-films/artifacts/68eydqj2_502665090_2169467683503831_8773769731831841376_n.jpg',
      icon: GraduationCap
    }
  ];

  const gallery = [
    {
      image: 'https://customer-assets.emergentagent.com/job_rrammy-films/artifacts/bm2rtn0s_502619474_2169467620170504_7133904791507209077_n.jpg',
      caption: 'Speaking at IIT Bombay APT 2025'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_rrammy-films/artifacts/1vn2rtkc_492726453_2169477826836150_6781234167720976936_n.jpg',
      caption: 'Receiving recognition at APT 2025'
    },
    {
      image: 'https://customer-assets.emergentagent.com/job_rrammy-films/artifacts/3nvxaog7_499926252_2162950437488889_5379700453085274989_n.jpg',
      caption: 'With colleagues and award'
    }
  ];

  return (
    <section className="bg-white py-20 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-light text-gray-800 mb-4">
            Recognition & Workshops
          </h2>
          <p className="text-gray-600 font-light">
            Awards, speaking engagements, and contributions to film education
          </p>
        </div>

        {/* Main Achievements */}
        <div className="space-y-16 mb-20">
          {achievements.map((item, index) => (
            <div
              key={index}
              className={`grid grid-cols-1 lg:grid-cols-2 gap-12 items-center ${
                index % 2 === 0 ? '' : 'lg:grid-flow-dense'
              }`}
            >
              {/* Image */}
              <div className={`${index % 2 === 0 ? '' : 'lg:col-start-2'}`}>
                <div className="relative overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-auto object-cover"
                  />
                </div>
              </div>

              {/* Content */}
              <div className={`space-y-6 ${index % 2 === 0 ? '' : 'lg:col-start-1 lg:row-start-1'}`}>
                <div className="flex items-center space-x-3">
                  <div className="w-12 h-12 flex items-center justify-center bg-gray-100">
                    <item.icon className="text-gray-700" size={24} />
                  </div>
                  <span className="text-xs uppercase tracking-wider text-gray-500">
                    {item.year}
                  </span>
                </div>

                <div>
                  <h3 className="text-3xl font-light text-gray-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-lg text-gray-600 font-light mb-4">
                    {item.subtitle}
                  </p>
                  <p className="text-gray-700 leading-relaxed font-light">
                    {item.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Gallery */}
        <div className="border-t border-gray-200 pt-16">
          <h3 className="text-2xl font-light text-gray-800 mb-8 text-center">
            Event Gallery
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {gallery.map((item, index) => (
              <div key={index} className="group">
                <div className="relative overflow-hidden bg-gray-100 aspect-square">
                  <img
                    src={item.image}
                    alt={item.caption}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                </div>
                <p className="text-sm text-gray-600 font-light mt-3 text-center">
                  {item.caption}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Footer Note */}
        <div className="text-center mt-16">
          <p className="text-gray-500 font-light text-sm">
            Available for workshops, masterclasses, and speaking engagements
          </p>
        </div>
      </div>
    </section>
  );
};

export default RecognitionWorkshops;
